document.addEventListener("DOMContentLoaded", function () {
  // Get all dropdown elements
  const dropdowns = document.querySelectorAll(".dropdown");
  // Get the mobile menu toggle button
  const mobileToggleCta = document.querySelector(".mobile-toggle-cta");
  const closeCross = document.querySelector(".close-cross");
  // Get the main navigation element
  const mainNav = document.getElementById("main_nav");

  // Function to handle dropdown hover events
  function handleDropdownHover(dropdown) {
    const dropdownToggle = dropdown.querySelector(".dropdown-toggle");
    const dropdownMenu = dropdown.querySelector(".dropdown-menu");

    dropdown.addEventListener("mouseover", () => {
      dropdown.classList.add("show");
      dropdownToggle.setAttribute("aria-expanded", "true");
      dropdownMenu.classList.add("show");
    });

    // Mouseout event listener to close on desktop
    dropdown.addEventListener("mouseout", () => {
      // Only close if screen width is larger than 768px (desktop)
      if (window.innerWidth >= 768) {
        dropdown.classList.remove("show");
        dropdownToggle.setAttribute("aria-expanded", "false");
        dropdownMenu.classList.remove("show");
      }
    });
  }

  // Function to handle window resize events
  function handleWindowResize() {
    // Check if the screen width is larger than 768px
    if (window.innerWidth >= 768) {
      // Add hover event listeners to each dropdown
      dropdowns.forEach((dropdown) => {
        handleDropdownHover(dropdown);
      });
      // Ensure body overflow is set to auto
      document.body.style.overflow = "auto";
    } else {
      // Remove hover event listeners from each dropdown
      dropdowns.forEach((dropdown) => {
        dropdown.removeEventListener("mouseover", handleDropdownHover);
        dropdown.removeEventListener("mouseout", handleDropdownHover);
      });
    }
  }

  // Add event listener for window resize
  window.addEventListener("resize", handleWindowResize);

  // Call handleWindowResize on initial load
  handleWindowResize();

  // Add event listener for mobile menu toggle button
  mobileToggleCta.addEventListener("click", function () {
    // Show/hide the mobile nav
    if (this.classList.contains("collapsed")) {
      mainNav.classList.remove("show");
      this.classList.add("collapsed");
      document.body.style.overflow = "auto";
    } else {
      mainNav.classList.add("show");
      this.classList.remove("collapsed");
      document.body.style.overflow = "hidden";
    }
  });
});
